<template>
    <div class="page-studentCredit">
        <el-row :gutter="20" style="display:flex;">
            <el-col :span="6" class="credit-left">
                <statistics-multi-orgs @orgsChange="orgsChange" @dataLoaded="orgDataLoaded"></statistics-multi-orgs>
            </el-col>
            <el-col :span="18" class="credit-right">
                <ui-card title="学分管理" icon="nucfont inuc-menu-assemble" class="ibox">
                    <el-form class="credit-query" :model="formSearch" :inline="true" size="mini">
                        <el-form-item :label="$t('c.userInfo')">
                            <el-input v-model="formSearch.search" :placeholder="$t('tip.userSearch')" style="width:180px"
                                      @keyup.enter.native="query(1)" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <advanced-date-picker @change="dateChange"></advanced-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="query(1)" round>{{$t('c.query')}}</el-button>
                        </el-form-item>
                    </el-form>

                    <el-button-group class="btn-group">
                        <el-tooltip class="item" effect="dark" content="学时排序" placement="top-start" :hide-after="1000">
                            <el-button size="small" @click="orderChange(1)" :class="sort.hours?'btn-active': 'btn-not-active'">
                                <i class="nucfont inuc-clock-o"></i>
                                <i class="nucfont inuc-sort-asc" v-if="sort.hours"
                                   :class="sort.hours ==='Asc'?'inuc-sort-asc':'inuc-sort-desc'"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="学分排序" placement="top-start" :hide-after="1000">
                            <el-button size="small" @click="orderChange(2)" :class="sort.credit?'btn-active': 'btn-not-active'">
                                <i class="nucfont inuc-key-topic"></i>
                                <i class="nucfont inuc-sort-asc" v-if="sort.credit"
                                   :class="sort.credit ==='Asc'?'inuc-sort-asc':'inuc-sort-desc'"></i>
                            </el-button>
                        </el-tooltip>
                    </el-button-group>

                    <div class="credit-table">
                        <data-tables-server ref="examTable"
                                     :data="tableData"
                                     :total="tableDataLength"
                                     :table-props="tableProps"
                                     :current-page.sync="currentPage"
                                     :page-size="pageSize"
                                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                     header-align="center"
                                     @query-change="onPage"
                        >
                            <el-table-column type="index" width="40" align="center"></el-table-column>

                            <!-- column title -->
                            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                             :key="title.label"
                                             show-overflow-tooltip
                                             align="center">
                            </el-table-column>

                            <!-- column buttons -->
                            <el-table-column :label="$t('c.operation')" align="center" width="90">
                                <div class="btn-cell" slot-scope="scope">
                                    <i class="nucfont inuc-preview"
                                       :title="$t('c.view')"
                                       @click="viewCreditDetail(scope.row)"></i>
                                </div>
                            </el-table-column>
                        </data-tables-server>
                    </div>
                </ui-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { Ticket, Debounce } from '@/utils'
    import StatisticsMultiOrgs from '@/components/Statistics/StatisticsMultiOrgs'
    import uiCard from '@/components/Statistics/StatisticUICard.vue'
    import AdvancedDatePicker from '@/components/DatePickerAdvanced'

    export default {
        components: {
            StatisticsMultiOrgs,
            uiCard,
            AdvancedDatePicker
        },
        data() {
            return {
                formSearch: {
                    name: '',
                    orgIds: [],
                    startTime: '',
                    endTime: ''
                },
                titles: [
                    {
                        prop: 'name',
                        label: this.$t('c.username')
                    },  {
                        prop: 'account',
                        label: this.$t('c.account')
                    },  {
                        prop: 'orgName',
                        label: this.$t('c.belong')
                    },  {
                        prop: 'hours',
                        label: this.$t('train.hour')
                    },  {
                        prop: 'credit',
                        label: this.$t('train.credit')
                    },
                ],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: document.documentElement.clientHeight-430
                },
                sort: {
                    hours: '',
                    credit: ''
                },
                tableData: [],
                tableDataLength: 0,
                currentPage: 1,
                pageSize: 20,
                searchData: {},
            }
        },
        computed: {},
        mounted() {

        },
        methods: {
            orgDataLoaded() {
                this.$nextTick(() => {
                    $('.page-studentCredit .el-tree > .el-tree-node').eq(0).find('.el-checkbox:eq(0)').click();
                })
            },

            orgsChange: Debounce(function (data) {
                this.formSearch.orgIds = data;

                this.query(1)
            }, 600),

            onPage(q) {
                if (q.type === 'init') return
                this.currentPage = q.page
                this.pageSize = q.pageSize
                this.query()
            },

            query(num) {
                if (num) {
                    this.currentPage = num
                }

                let searchData = {
                    ...this.formSearch,
                    PageNO: this.currentPage,
                    Limit: this.pageSize,
                }

                if (this.sort.hours) {
                    searchData.sortName = 'hours'
                    searchData.order = this.sort.hours
                }
                if (this.sort.credit) {
                    searchData.sortName = 'credit'
                    searchData.order = this.sort.credit
                }

                this.$api.getCredit(searchData).then((res) => {
                    this.tableData = res.package;
                    this.tableDataLength = res.total
                })
            },

            orderChange(type) {
                if (type === 1) {
                    if (!this.sort.hours) {
                        this.sort.hours = 'Desc'
                    } else if (this.sort.hours === 'Desc') {
                        this.sort.hours = 'Asc'
                    } else {
                        this.sort.hours = ''
                    }
                    this.sort.credit = ''
                }
                if (type === 2) {
                    if (!this.sort.credit) {
                        this.sort.credit = 'Desc'
                    } else if (this.sort.credit === 'Desc') {
                        this.sort.credit = 'Asc'
                    } else {
                        this.sort.credit = ''
                    }
                    this.sort.hours = ''
                }

                this.query()
            },

            dateChange(time) {
                this.formSearch.startTime = time[0]
                this.formSearch.endTime = time[1]
            },

            viewCreditDetail(data) {
                let params = {
                    userID: data.userid,
                    searchData: {
                        endTime: this.formSearch.endTime,
                        startTime: this.formSearch.startTime,
                    }
                }

                this.$emit('to-detail', params)
            },
        },
    }
</script>

<style scoped lang="scss">
    .page-studentCredit {
        /deep/ .ui-card {
            margin-bottom: 0;
            box-shadow: none;
            border: 1px solid #dedede;

            .card-body {
                max-height: 670px;
            }
        }
    }

    .credit-left {
        .grid-content {
            height: 100%;
        }
        & /deep/ .ibox {
            height: 100%;
            .el-tree {
                height: 100%;
            }
        }
    }

    .credit-right {
        //border-left: 1px dashed #ddd;
    }

    .credit-query {
        padding: 20px 0 0 10px;
    }

    .btn-group {
        margin: 0 0 10px 10px;
    }
    .btn-active{
        background-color: #22B9FF;
        color:#fff;
    }
    .btn-not-active{
        background-color: #fff;
        color:#606266;
        border-color: #dcdfe6;
        &:hover{
            color: #22B9FF;
            border-color: #bdeaff;
            background-color: #e9f8ff;
        }
    }
</style>
